export function isConfirmationGateSelfTarget(target: string, currentPath: string, baseUrl: string): boolean {
    const currentUrl = new URL(currentPath, baseUrl);
    const targetUrl = new URL(target, currentUrl);
    const normalizePath = (pathname: string) => pathname.replace(/\/+$/, '') || '/';

    // Query strings and fragments do not leave the gated story.
    return (
        targetUrl.origin === currentUrl.origin &&
        normalizePath(targetUrl.pathname) === normalizePath(currentUrl.pathname)
    );
}
